module.exports = __webpack_public_path__ + "img/IMAGE10.397d4282.jpg";